"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _partial = _interopRequireDefault(require("transmute/partial"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _colors = require("HubStyleTokens/colors");

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H3"));

var _UIScrollContainer = _interopRequireDefault(require("UIComponents/scroll/UIScrollContainer"));

var _Terms = require("self-service-api/constants/Terms");

var _MerchandiseSelectors = require("pricing-pages-unified-ui/selectors/MerchandiseSelectors");

var _GrowthSuiteCatalogEditionHeader = _interopRequireDefault(require("pricing-pages-unified-ui/components/growth-suite-catalog/GrowthSuiteCatalogEditionHeader"));

var _GrowthSuiteCatalogFeaturesTable = _interopRequireDefault(require("pricing-pages-unified-ui/components/growth-suite-catalog/GrowthSuiteCatalogFeaturesTable"));

var _FooterMicrocopy = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/FooterMicrocopy"));

var _PriceDisplay = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/pricing/PriceDisplay"));

var _Hubs = require("self-service-api/constants/Hubs");

var _SuiteEditionMerchIdMap = _interopRequireDefault(require("pricing-pages-unified-ui/constants/SuiteEditionMerchIdMap"));

var _PromotionSelectors = require("../../selectors/PromotionSelectors");

var _Editions = require("self-service-api/constants/Editions");

var _CovidSelectors = require("../../selectors/CovidSelectors");

var _PricingSelectors = require("../../selectors/PricingSelectors");

var _MarketingContactsSelectors = require("../../selectors/MarketingContactsSelectors");

var MODAL_WIDTH = 1200;
var HEADER_HEIGHT = 128;
var MODAL_TOP_MARGIN = 60;
var MODAL_BOTTOM_MARGIN = 47;
var growthSuiteHubs = ['marketing', 'sales', 'service'];
var growthSuiteEditions = ['starter', 'professional', 'enterprise'];

var ModalHeader = _styledComponents.default.div.withConfig({
  displayName: "GrowthSuiteCatalogModal__ModalHeader",
  componentId: "kc3lnk-0"
})(["text-align:center;z-index:100;background-color:", ";padding:15px 0;& > h3{margin:0;}img{height:20px;}"], _colors.GYPSUM);

var PricingContainer = _styledComponents.default.div.withConfig({
  displayName: "GrowthSuiteCatalogModal__PricingContainer",
  componentId: "kc3lnk-1"
})(["margin:0 auto;"]);

var Price = _styledComponents.default.div.withConfig({
  displayName: "GrowthSuiteCatalogModal__Price",
  componentId: "kc3lnk-2"
})(["font-size:20px;color:", ";margin-right:8px;font-weight:600;display:inline-block;"], _colors.OZ);

var CrossedOutPrice = (0, _styledComponents.default)(_PriceDisplay.default).withConfig({
  displayName: "GrowthSuiteCatalogModal__CrossedOutPrice",
  componentId: "kc3lnk-3"
})(["color:", ";font-size:16px;line-height:27px;text-decoration:line-through;"], _colors.PANTERA);

var CrossOutPerMonth = _styledComponents.default.span.withConfig({
  displayName: "GrowthSuiteCatalogModal__CrossOutPerMonth",
  componentId: "kc3lnk-4"
})(["font-size:16px;line-height:27px;text-decoration:line-through;"]);

var StyledSelect = (0, _styledComponents.default)(_UISelect.default).withConfig({
  displayName: "GrowthSuiteCatalogModal__StyledSelect",
  componentId: "kc3lnk-5"
})(["width:fit-content;margin:8px auto 16px;font-size:26px;.private-dropdown__caret{font-size:20px;color:", ";margin-left:8px;}.growth-suite-bold{font-weight:700;}"], _colors.CALYPSO);

var GrowthSuiteCatalogModal = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(GrowthSuiteCatalogModal, _React$Component);

  function GrowthSuiteCatalogModal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, GrowthSuiteCatalogModal);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(GrowthSuiteCatalogModal).call(this, props));
    _this.state = {
      activeGrowthSuiteEdition: _this.props.edition
    };
    return _this;
  }

  (0, _createClass2.default)(GrowthSuiteCatalogModal, [{
    key: "getOption",
    value: function getOption(edition) {
      var text = _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "pricingPage.pages.growthSuite.catalogModal." + edition
      });

      var option = {
        dropdownText: text,
        buttonText: text,
        value: edition
      };
      return option;
    }
  }, {
    key: "getPricingInfo",
    value: function getPricingInfo() {
      var isCovidPromo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _this$props = this.props,
          calculateBundlePrice = _this$props.calculateBundlePrice,
          getGrowthSuiteAvailableTerms = _this$props.getGrowthSuiteAvailableTerms,
          isInMCBeta = _this$props.isInMCBeta;
      var activeGrowthSuiteEdition = this.state.activeGrowthSuiteEdition;
      var growthSuiteAvailableTerms = getGrowthSuiteAvailableTerms(isCovidPromo)[activeGrowthSuiteEdition];
      var defaultTerm = growthSuiteAvailableTerms[_Terms.MONTHLY] ? _Terms.MONTHLY : _Terms.ANNUAL;
      return calculateBundlePrice({
        bundleSelections: {
          marketingPlanSelected: (0, _SuiteEditionMerchIdMap.default)(isInMCBeta)[activeGrowthSuiteEdition][_Hubs.HUB_MARKETING],
          salesPlanSelected: (0, _SuiteEditionMerchIdMap.default)(isInMCBeta)[activeGrowthSuiteEdition][_Hubs.HUB_SALES],
          servicePlanSelected: (0, _SuiteEditionMerchIdMap.default)(isInMCBeta)[activeGrowthSuiteEdition][_Hubs.HUB_SERVICE]
        },
        term: defaultTerm,
        isGrowthSuite: true,
        isCovidPromo: isCovidPromo
      });
    }
  }, {
    key: "renderGrowthSuiteEditionSelector",
    value: function renderGrowthSuiteEditionSelector() {
      var _this2 = this;

      return _react.default.createElement(StyledSelect, {
        buttonUse: "unstyled",
        onChange: function onChange(evt) {
          return _this2.setState({
            activeGrowthSuiteEdition: evt.target.value
          });
        },
        options: growthSuiteEditions.map(function (edition) {
          return _this2.getOption(edition);
        }),
        value: this.state.activeGrowthSuiteEdition,
        searchable: false,
        menuWidth: "auto"
      });
    }
  }, {
    key: "renderModalHeader",
    value: function renderModalHeader() {
      var _this$props2 = this.props,
          onCloseClick = _this$props2.onCloseClick,
          currencyCode = _this$props2.currencyCode,
          isCovidGrowthSuitePromoEligible = _this$props2.isCovidGrowthSuitePromoEligible;
      var activeGrowthSuiteEdition = this.state.activeGrowthSuiteEdition;
      var shouldApplyCovidPromo = isCovidGrowthSuitePromoEligible && activeGrowthSuiteEdition === _Editions.STARTER;
      var pricingInfo = this.getPricingInfo(shouldApplyCovidPromo);
      var originalDiscountedPrice = this.getPricingInfo(false).monthly.calculatedPrice;
      return _react.default.createElement(ModalHeader, null, _react.default.createElement(_H.default, {
        className: "display-inline"
      }, this.renderGrowthSuiteEditionSelector(), _react.default.createElement(PricingContainer, null, _react.default.createElement(Price, null, _react.default.createElement(_PriceDisplay.default, {
        price: pricingInfo.monthly.calculatedPrice,
        currencyCode: currencyCode
      }), _react.default.createElement(_FormattedMessage.default, {
        message: "pricingPage.calculator.priceDisplay.perMonth"
      })), _react.default.createElement(CrossedOutPrice, {
        price: shouldApplyCovidPromo ? originalDiscountedPrice : pricingInfo.monthly.fullPrice,
        currencyCode: currencyCode
      }), _react.default.createElement(CrossOutPerMonth, null, _react.default.createElement(_FormattedMessage.default, {
        message: "pricingPage.calculator.priceDisplay.perMonth"
      })))), _react.default.createElement(_UIDialogCloseButton.default, {
        onClick: (0, _partial.default)(onCloseClick)
      }));
    }
  }, {
    key: "renderGrowthHubEditionTable",
    value: function renderGrowthHubEditionTable(hub) {
      var _this$props3 = this.props,
          currencyCode = _this$props3.currencyCode,
          products = _this$props3.products;
      var activeGrowthSuiteEdition = this.state.activeGrowthSuiteEdition;
      return _react.default.createElement(_react.default.Fragment, {
        key: hub
      }, _react.default.createElement(_GrowthSuiteCatalogEditionHeader.default, {
        currencyCode: currencyCode,
        edition: activeGrowthSuiteEdition,
        products: products,
        hub: hub
      }), _react.default.createElement(_GrowthSuiteCatalogFeaturesTable.default, {
        hub: hub,
        edition: activeGrowthSuiteEdition
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return _react.default.createElement(_UIModal.default, {
        use: "conversational",
        width: MODAL_WIDTH,
        style: {
          minWidth: '900px'
        }
      }, this.renderModalHeader(), _react.default.createElement(_UIScrollContainer.default, {
        maxHeight: "calc(100vh - " + (HEADER_HEIGHT + MODAL_TOP_MARGIN + MODAL_BOTTOM_MARGIN) + "px)",
        scrollDirection: 'vertical'
      }, growthSuiteHubs.map(function (hub) {
        return _this3.renderGrowthHubEditionTable(hub);
      }), _react.default.createElement(_FooterMicrocopy.default, null)));
    }
  }]);
  return GrowthSuiteCatalogModal;
}(_react.default.Component);

GrowthSuiteCatalogModal.propTypes = {
  currencyCode: _propTypes.default.string.isRequired,
  edition: _propTypes.default.string.isRequired,
  products: _propTypes.default.object.isRequired,
  onCloseClick: _propTypes.default.func.isRequired,
  getGrowthSuiteAvailableTerms: _propTypes.default.func.isRequired,
  isCovidGrowthSuitePromoEligible: _propTypes.default.bool,
  calculateBundlePrice: _propTypes.default.func.isRequired,
  isInMCBeta: _propTypes.default.bool
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    products: (0, _MerchandiseSelectors.merchandiseSelector)(state),
    getGrowthSuiteAvailableTerms: function getGrowthSuiteAvailableTerms(isCovidPromo) {
      return (0, _PromotionSelectors.growthSuiteAvailableTermsSelector)(state, isCovidPromo);
    },
    isCovidGrowthSuitePromoEligible: (0, _CovidSelectors.isCovidGrowthSuitePromoEligibleSelector)(state),
    calculateBundlePrice: (0, _PricingSelectors.getCalculateBundlePriceSelector)(state),
    isInMCBeta: (0, _MarketingContactsSelectors.isInMCBetaSelector)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(GrowthSuiteCatalogModal);

exports.default = _default;
module.exports = exports.default;